import React, { useState, useEffect } from "react";
import moment from "moment";
import attachDocument from '../../../../layout/Logistic/Attachment'

import {
  Container,
  Title,
  ItemDetails,
  Left,
  Details,
} from "./styles";


import Loading from '~/components/layout/Loading';

export default function MobileCashPayment({ data, handleShowButton }) {
  const [fileAttached, setFileAttached] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(()=>{
    handleShowButton({id: data.id, status:fileAttached })
  },[fileAttached])

  const formattedValue = data.netValue.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })

  return (
    <Container className="mb-3">
      {data.status === "PAGO" ? (
        <Left>O comprovante que deseja anexar já foi registrado como pago em nossos sistemas.</Left>
      ) : (
       <>   
        <Left>
         <ItemDetails>Pedido: </ItemDetails>
         <Title>{data.number}</Title>
        </Left>
        <Left>
          <ItemDetails>Vencimento: </ItemDetails>
          <Title>{moment(data.expirationDate).format("DD/MM/YY")}</Title>
        </Left>
        <Left>
          <ItemDetails>Valor: </ItemDetails>
          <Title>
            {formattedValue}
          </Title>
        </Left>
        <Left>
          {isLoading ? (
              <Loading margin={"0px"} />
          ) : (
            <Details
              color={fileAttached}
              onClick={() => {
                attachDocument(data.id, setFileAttached, setIsLoading);
              }}
            >
              Anexar comprovante
            </Details>
          )}
        </Left>
       </>
        )}
    </Container>
  );
}
